import { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CircularProgress } from "@mui/material";

import VuiBox from "components/VuiBox";
import VuiTypography from "components/VuiTypography";
import VuiButton from "components/VuiButton";
import CoverLayout from "layouts/authentication/components/CoverLayout";

import useCommon from "hooks/useCommon";
import { verifyEmail } from "store/slice/verificationSlice";
import { resetVerificationState } from "store/slice/verificationSlice";
// import { verifyEmail, resetVerificationState } from "store/slice/verificationSlice";

const VerifyEmail = () => {
  const { STORE, DISPATCH } = useCommon();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = searchParams.get("token");

  const { verifying, verified, error } = STORE((state) => state.verification);

  useEffect(() => {
    return () => {
      DISPATCH(resetVerificationState());
    };
  }, [DISPATCH]);

  useEffect(() => {
    if (verified) {
      setTimeout(() => {
        navigate("/authentication/sign-in");
      }, 2000);
    }
  }, [verified, navigate]);

  const handleVerify = () => {
    if (!token) return;
    DISPATCH(verifyEmail({ token }));
  };

  return (
    <CoverLayout>
      <VuiBox display="flex" flexDirection="column" alignItems="center" textAlign="center" px={3}>
        <VuiTypography variant="h4" mb={1}>
          Verify your email
        </VuiTypography>

        <VuiTypography variant="body2" mb={3}>
          Click the button below to confirm your email address.
        </VuiTypography>

        {verifying && <CircularProgress size={28} sx={{ mb: 2 }} />}

        {verified && (
          <VuiTypography color="success" mb={2}>
            Your email has been successfully verified.
          </VuiTypography>
        )}

        {error && (
          <VuiTypography color="error" mb={2}>
            {error}
          </VuiTypography>
        )}

        {!verified && (
          <VuiButton
            variant="outlined"
            color="primary"
            onClick={handleVerify}
            disabled={verifying || !token}
            fullWidth
          >
            Verify Email
          </VuiButton>
        )}
      </VuiBox>
    </CoverLayout>
  );
};

export default VerifyEmail;
